var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditCaseDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1747 4H4.17474C3.64431 4 3.1356 4.21071 2.76053 4.58579C2.38546 4.96086 2.17474 5.46957 2.17474 6V20C2.17474 20.5304 2.38546 21.0391 2.76053 21.4142C3.1356 21.7893 3.64431 22 4.17474 22H18.1747C18.7052 22 19.2139 21.7893 19.589 21.4142C19.964 21.0391 20.1747 20.5304 20.1747 20V13",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6747 2.50023C19.0726 2.1024 19.6121 1.87891 20.1747 1.87891C20.7374 1.87891 21.2769 2.1024 21.6747 2.50023C22.0726 2.89805 22.2961 3.43762 22.2961 4.00023C22.2961 4.56284 22.0726 5.1024 21.6747 5.50023L12.1747 15.0002L8.17474 16.0002L9.17474 12.0002L18.6747 2.50023Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCaseDetails);
export default __webpack_public_path__ + "static/media/edit_case_details.c599f27f4d5732a8962dd68acbe66e8b.svg";
export { ForwardRef as ReactComponent };